import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appNoSpace]',
    standalone: false
})
export class NoSpaceDirective {
  constructor(private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const trimmed = input.value.replace(/\s+/g, '');
    this.control.control?.setValue(trimmed);
  }
}
